var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Notes / Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47631 2.643C2.5 3.61931 2.5 5.19066 2.5 8.33335V11.6667C2.5 14.8094 2.5 16.3807 3.47631 17.357C4.45262 18.3334 6.02397 18.3334 9.16667 18.3334H10.8333C13.976 18.3334 15.5474 18.3334 16.5237 17.357C17.5 16.3807 17.5 14.8094 17.5 11.6667V8.33335C17.5 5.19066 17.5 3.61931 16.5237 2.643C15.5474 1.66669 13.976 1.66669 10.8333 1.66669H9.16667C6.02397 1.66669 4.45262 1.66669 3.47631 2.643ZM6.66667 7.70835C6.32149 7.70835 6.04167 7.98818 6.04167 8.33335C6.04167 8.67853 6.32149 8.95835 6.66667 8.95835H13.3333C13.6785 8.95835 13.9583 8.67853 13.9583 8.33335C13.9583 7.98818 13.6785 7.70835 13.3333 7.70835H6.66667ZM6.66667 11.0417C6.32149 11.0417 6.04167 11.3215 6.04167 11.6667C6.04167 12.0119 6.32149 12.2917 6.66667 12.2917H10.8333C11.1785 12.2917 11.4583 12.0119 11.4583 11.6667C11.4583 11.3215 11.1785 11.0417 10.8333 11.0417H6.66667Z",
    fill: "#22C55E"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/greenNote.7b8c3443ca3b5d29178968568bb88761.svg";